module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2b7f706af117e45b1f3717e929eba19e.png";